import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CadastroService } from 'src/app/cadastro/cadastro.service';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { PasswordRecoveryService } from 'src/app/shared/services/password-recovery.service';
import { ToastService } from 'src/app/shared/toast';

type UserRecoveryInfo = {
  email: string;
  phone: string;
};

export type SelectedConfirmTokenMethod = {
  token: string;
  method: 'PHONE' | 'EMAIL';
}

@Component({
  selector: 'app-verification-method-selection-page',
  templateUrl: './verification-method-selection-page.component.html',
  styleUrls: ['./verification-method-selection-page.component.scss']
})
export class VerificationMethodSelectionPageComponent implements OnInit {

  userDocument: string;
  recaptcha: string;
  userRecoveryInfo: UserRecoveryInfo;
  token: string;
  isMinorThanTablet: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 768px)');

  constructor(
    private cadastroService: CadastroService,
    private passwordRecoveryService: PasswordRecoveryService,
    private authService: AutenticacaoService,
    private router: Router,
    private location: Location,
    private loader: LoaderService,
    private toast: ToastService,
    public breakpointObserver: BreakpointObserver,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit(): void {
    const userRecoveryInfo = this.passwordRecoveryService.getSelectedVerificationMethodInfo();

    if (userRecoveryInfo) {
      this.userRecoveryInfo = {
        email: userRecoveryInfo.methodsData.email,
        phone: userRecoveryInfo.methodsData.phone,
      }

      return;
    }

    this.userDocument = this.cadastroService.getUserDocumentFromSessionStorage();
    this.recaptcha = this.cadastroService.getRecaptcha();

    if (!this.userDocument || !this.recaptcha) {
      this.router.navigate(['/']);
      return;
    }

    this.googleAnalyticsService.pushPageViewEvent({
      page_name: '/renegocie/recuperar_senha',
      page_template: 'renegocie',
     }, {
      user_status_login: 'deslogado',
    });

    this.authenticateUserToPasswordRecovery();
  }

  async authenticateUserToPasswordRecovery() {
    try {
      this.loader.start();
      const response = await this.passwordRecoveryService.authPasswordRecovery({
        bandeira: this.authService.bandeira,
        cpf: this.userDocument,
        recaptcha: this.recaptcha,
      })

      if (!response) {
        this.toast.show({ type: 'warning', title: 'Você ainda não tem cadastro', text: 'Faça seu cadastro para ter acesso ao Portal e tudo sobre seu carnê.' });
        this.router.navigate(['']);
        return
      }

      this.userRecoveryInfo = {
        email: response.email,
        phone: response.phone.slice(3),
      }
      this.token = response.token;
      this.passwordRecoveryService.setPasswordRecoveryAuthToken(this.token);
    } catch (error) {
      this.googleAnalyticsService.pushActionEvent({
        event: 'view_error',
        detail: error?.error?.message || 'Erro ao buscar informações para alteração de senha'
      });
      this.toast.show({ type: 'error', title: 'Erro ao buscar informações', text: 'Não foi possível buscar informações para a alteração de senha. Tente novamente mais tarde!' });
      this.router.navigate(['']);
    } finally {
      this.loader.stop();
    }
  }

  selectVerificationMethod(selectedMethod: 'PHONE' | 'EMAIL') {
    const gaActionDetail = selectedMethod === 'PHONE' ? 'enviar sms para o celular' : 'enviar e-mail para:';
    this.googleAnalyticsService.pushActionEvent({
      event: 'click',
      detail: gaActionDetail
    });

    if (!this.passwordRecoveryService.getPasswordRecoveryAuthToken()) {
      this.passwordRecoveryService.setPasswordRecoveryAuthToken(this.token);
    }

    const selectedMethodKey = selectedMethod.toLocaleLowerCase();

    this.passwordRecoveryService.setSelectedVerificationMethodInfo({
      selectedMethod: selectedMethod,
      selectedMethodData: this.userRecoveryInfo[selectedMethodKey],
      methodsData: {
        email: this.userRecoveryInfo.email,
        phone: this.userRecoveryInfo.phone
      }
    });

    this.router.navigate(['/recuperar-senha/confirmar-token'])
  }

  handleGoBack() {
    this.location.back();
  }

}
